import log from 'salvo-lite/log'

class Variant {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener('change', () => {
            this._updateUrl(this._elem.value)
        })
    }
    _updateUrl (variantID) {
        const newUrl = `${window.location.origin}${window.location.pathname}?variant=${variantID}`
        window.history.pushState({path: newUrl}, '', newUrl)
    }
}

export default Variant



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Variant.js